<template>
    <div class="designeroption" :data-designer-component-id="component_id" v-show="ranges.length > 1">
        <h3>{{ title }}</h3>
        <div class="stylesoption designer-question-tiled-layout _3-col">
            <div v-for="range in ranges" @click.prevent="switch_range(range.id)" :class="['tile', target == range.id ? 'active' : '']">
                <a href="#!">
                    <img :src="thumbURL + 'doortype-' + range.thumbnail + '.jpg'" alt="">
                    <i class="fa fa-check" aria-hidden="true"></i>
                </a>
            </div>
        </div>
    </div>
    <div v-show="target == 11 || target == 162 || target == 163" class="designeroption">
        <div class="stylesoption p-6">
            <strong class="mb-3">All Truedors are fitted with the following as standard:</strong>
            <ul class="mb-0">
                <li>
                    Cylinders are 3*
                </li>
                <li>
                    Handles are 1* DDA Approved Levers
                </li>
                <li>
                    Laminated safety glass meets requirements of BS EN 356:2000
                </li>
                <li>
                    Lever and cylinder combination provide a 3* security rating to TS007.
                </li>
            </ul>
        </div>
    </div>
    <div v-show="target == 46" class="designeroption">
        <div class="stylesoption p-6">
            <strong class="mb-3">Featuring Laminated Glass and extra security features.</strong>
            <ul class="mb-0">
                <li>
                    The Truedor XTR Range of PAS24:2012 compliant doorsets are suitable for meeting Approved Document Q of the building regulations in England and Scotland.
                </li>
                <li>
                    In order to meet ADQ in Wales you will need to order from the Truedor Secured By Design range.
                </li>
            </ul>
        </div>
    </div>
    <div v-show="target == 47" class="designeroption">
        <div class="stylesoption p-6">
            <strong class="mb-3">As Truedor Enhanced Security but with the Trojan TS008 Unicorn letter plate.</strong>
            <ul class="mb-0">
                <li>
                    The Truedor HTR Range of PAS24:2016 compliant doorsets are SBD licenced products.
                </li>
                <li>
                    SBD is the UK Police flagship initiative supporting the principles of designing out crime.
                </li>
            </ul>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
    import DesignerQuestionDoorRange from "../DesignerQuestionDoorRange.vue";

    export default {
        mixins: [
            DesignerQuestionDoorRange
        ],
        computed: {
            thumbURL(){
                return '/images/truedor/';
            },
        },
        methods: {
          switch_range(range) {
              window.emitter.emit('new-door', this.defaultdoor[range], this.reference_on);
              window.emitter.emit('range-updated');
          },
        },
    }
</script>
